<template>
  <div id="accountInformation" :class="['gradient-card', 'card', {'plain-card': ($utils.isPageForLicenses())}]">
    <div class="header">
      <h4 class="title">{{panelHeaderTitle}}</h4>
    </div>

    <div class="body contact">
      <!-- Account Downgraded content -->
      <template v-if="userInfo._edit && content === contentOptions.planDowngraded">
        <div id="planDowngraded">
          <div class="icon"></div>
          <div class="desc">{{$t('plans.downgradedToFreeDesc', { plan: $utils.options.plans.DISCOVERY })}}</div>
        </div>
      </template>

      <!-- Account Deleted notification content -->
      <template v-if="userInfo._edit && content === contentOptions.accountDeleted">
        <div class="accountDeleted">
          <h1 class="delete-user-success-text">{{$t('label.accountIsDeleted')}}</h1>
          <p>{{$t('label.loggedOffInFewSeconds')}}</p>
        </div>
      </template>

      <template v-if="userInfo._edit && content === contentOptions.accountInfo" >
        <perfect-scrollbar
          class="account-info-content-wrapper cstm-ps-scrollbar-vertical"
          :options="{ suppressScrollX: true }"
        >
          <div class="content-col col-1">
            <!-- Account Name -->
            <div class="item">
              <div class="label">{{$t('label.accountName')}}</div>
              <div class="val">
                <div id="accountName" :class="[{'editable': enableEditAccountName}]">
                  <div class="account-name-content">
                    <div class="account-name">{{userInfo._edit.accountInformation.accountName}}</div>
                    <div v-if="enableEditAccountName" class="edit-icon" @click="handleEditAccountNameIconClick"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Account Plan -->
            <div class="item">
              <div class="label">{{$t('label.accountPlan')}}</div>
              <div class="val">{{userInfo._edit.accountInformation.accountPlanName}}</div>
            </div>

            <!-- Installed/Capacity -->
            <div class="item">
              <div class="label">
                <template v-if="userInfo._edit.plan.currentPlan === $utils.options.plans.PREMIUM">{{$t('label.installed')}}</template>
                <template v-else>{{$t('label.installedOrCapacity')}}</template>
              </div>
              <div class="val">{{userInfo._edit.accountInformation.installedOrCapacity}}</div>
            </div>

            <!-- Users-->
            <div class="item">
              <div class="label">{{$t('label.user', 2)}}</div>
              <div class="val">{{userInfo._edit.accountInformation.users }}</div>
            </div>

            <!-- Options -->
            <div v-if="userInfo._edit.accountInformation.options" class="item">
              <div class="label">{{$t('label.options')}}</div>
              <div class="val">{{userInfo._edit.accountInformation.options }}</div>
            </div>
          </div>

          <div class="content-col col-2">
            <!-- Arya Account ID -->
            <div class="item">
              <div class="label">{{$t('label.accountId')}}</div>
              <div class="val accountId flex items-start justify-start pl-0">
                <input :value="accountId"
                  ref="accountId"
                  class="w-[85%]
                    h-[20px]
                    text-ellipsis
                    whitespace-nowrap
                    overflow-hidden
                    px-0
                    py-0
                    bg-transparent
                    mr-[8px]
                    m-0
                    p-0
                    border-0"
                  :title="accountId"
                  readonly>
                  <div @click="handleCopyAccountId" class="cursor-pointer w-[18px] h-[18px] bg-[url('@/static/icons/copy-icon-black.svg')] bg-contain bg-no-repeat bg-center"></div>
              </div>
            </div>

            <!-- Subscription -->
            <div class="item">
              <div class="label">{{$t('label.expirationDate')}}</div>
              <div class="val">{{ userInfo._edit.accountInformation.subscription ?? $t('label.naText')}}</div>
            </div>

            <!-- Storage -->
            <div class="item">
              <div class="label">{{$t('label.storage')}}</div>
              <div class="val">{{userInfo._edit.accountInformation.storage}}</div>
            </div>

            <!-- Data Storage Region -->
            <div v-if="dataStorageRegionName" class="item">
              <div class="label">{{$t('label.dataStorageRegion')}}</div>
              <div class="val">{{ dataStorageRegionName }}</div>
            </div>
          </div>
        </perfect-scrollbar>

        <div class="actions">
          <div v-if="userInfo._edit.accountInformation.downgradeAccountEnabled" @click="handleDowngradePlan" class="action downgrade-account">{{$t('label.downgradeAccount')}}</div>
          <div v-if="userInfo._edit.accountInformation.deleteAccountEnabled" @click="handleDeleteAccount" class="action delete-account">{{$t('label.deleteAccount')}}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script src="./account-information.js"></script>
<style lang="scss" src="./account-information.scss"></style>
